// extracted by mini-css-extract-plugin
export default {"root":"HUhg","svg":"eY1N"};